import axios from 'axios'
import { type RankInfos } from '#app/routes/api+/internal+/get-rank-infos.js'

interface ImageUploadResponse {
	url: string
}

export class API {
	private static imageKitApiKey = 'private_9UAWJ3TSTFMkD+QD03T64lxJbbY='
	private static imageKitUrlEndpoint = 'https://ik.imagekit.io/waitless/'
	private static imageKitUploadEndpoint =
		'https://upload.imagekit.io/api/v1/files/upload'

	public static uploadImage = async (file: File): Promise<string> => {
		await new Promise(r => setTimeout(r, 500))

		const formData = new FormData()
		formData.append('file', file)
		formData.append('fileName', file.name)
		formData.append('useUniqueFileName', 'true')

		const response = await axios.post(this.imageKitUploadEndpoint, formData, {
			headers: {
				Authorization: `Basic ${btoa(this.imageKitApiKey + ':')}`,
			},
		})

		if (response.status !== 200) {
			throw new Error('Failed to upload image')
		}

		const data = response.data as ImageUploadResponse

		if (!data.url) {
			throw new Error('Image upload failed: No URL returned')
		}

		return `${data.url}?tr=w-1800,fo-auto,fl-lossy`
	}

	public static getRankInfos = async (subId: string): Promise<RankInfos> => {
		const formData = new FormData()
		formData.append('subId', subId)

		const response = await fetch('/api/internal/get-rank-infos', {
			method: 'GET',
		})

		if (!response.ok) {
			throw new Error('Failed to get infos')
		}

		const data = (await response.json()) as RankInfos

		return data
	}
}

export default API
